import { useState } from "react";
import { Plus, X } from "@phosphor-icons/react";
import {
  PhysicalCatalogPickers,
  PartnerCatalogPickers,
  KinkCatalogPicker,
} from "../catalog/CatalogTagPickers";

function TagField({ label, values, onChange, placeholder, testId }) {
  const [draft, setDraft] = useState("");
  function add() {
    const v = draft.trim();
    if (!v) return;
    if (values.includes(v)) return;
    onChange([...values, v]);
    setDraft("");
  }
  return (
    <div className="space-y-2" data-testid={testId}>
      <label className="zx-label">{label}</label>
      <div className="flex flex-wrap gap-2">
        {values.map((t) => (
          <span key={t} className="zx-tag accent">
            {t}
            <button
              type="button"
              onClick={() => onChange(values.filter((x) => x !== t))}
              className="ml-1 opacity-70 hover:opacity-100"
              aria-label={`Quitar ${t}`}
            >
              <X size={10} />
            </button>
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <input
          className="zx-input"
          placeholder={placeholder}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
        />
        <button
          type="button"
          onClick={add}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(184,50,90,0.45)] bg-[rgba(139,30,63,0.18)] text-[#e9b5c5] hover:bg-[rgba(139,30,63,0.32)]"
          aria-label="Añadir"
        >
          <Plus size={14} weight="thin" />
        </button>
      </div>
    </div>
  );
}

export default function ProfileForm({ profile, onSave, catalogs }) {
  const [nick, setNick] = useState(profile.nick || "");
  const [physicalAttributes, setPhysical] = useState(profile.physicalAttributes || []);
  const [preferences, setPreferences] = useState(profile.preferences || []);
  const [interests, setInterests] = useState(profile.interests || []);
  const [saving, setSaving] = useState(false);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave({ nick, physicalAttributes, preferences, interests });
    } finally {
      setSaving(false);
    }
  }

  return (
    <form
      onSubmit={handleSave}
      className="zx-card p-5 space-y-5"
      data-testid="profile-form"
    >
      <p className="zx-label">Perfil</p>
      <div className="space-y-1">
        <label className="zx-label" htmlFor="p-nick">Nick</label>
        <input
          id="p-nick"
          className="zx-input"
          value={nick}
          onChange={(e) => setNick(e.target.value)}
          data-testid="profile-nick-input"
        />
      </div>
      <div className="space-y-3">
        <PhysicalCatalogPickers
          catalogData={catalogs?.physical}
          isLoading={catalogs?.isLoading}
          values={physicalAttributes}
          onChange={setPhysical}
          testIdPrefix="profile-catalog-physical"
        />
        <TagField
          label="Características físicas"
          values={physicalAttributes}
          onChange={setPhysical}
          placeholder="Ej. Atlético, alto, moreno..."
          testId="profile-tags-physical"
        />
      </div>
      <div className="space-y-3">
        <PartnerCatalogPickers
          catalogData={catalogs?.partnerPreferences}
          isLoading={catalogs?.isLoading}
          values={preferences}
          onChange={setPreferences}
          testIdPrefix="profile-catalog-partner"
        />
        <TagField
          label="Preferencias"
          values={preferences}
          onChange={setPreferences}
          placeholder="Ej. Discreción, velas, anonimato..."
          testId="profile-tags-preferences"
        />
      </div>
      <div className="space-y-3">
        <KinkCatalogPicker
          catalogData={catalogs?.kinks}
          isLoading={catalogs?.isLoading}
          values={interests}
          onChange={setInterests}
          testIdPrefix="profile-catalog-kinks"
        />
        <TagField
          label="Gustos / intereses"
          values={interests}
          onChange={setInterests}
          placeholder="Ej. Sensorial, roleplay..."
          testId="profile-tags-interests"
        />
      </div>

      <button
        type="submit"
        className="zx-btn-primary"
        disabled={saving}
        data-testid="profile-save-button"
      >
        {saving ? "Guardando..." : "Guardar cambios"}
      </button>
    </form>
  );
}
